import { useEffect, useState } from 'react'
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react'
import { AppConfigV2 } from '@shopify/app-bridge'
import { AuthProvider, PlanProvider } from '@/context'
import RoutePropagator from '@/components/RoutePropagator'

export default function EmbeddedApp({ children }) {
  const SHOPIFY_APP_CLIENT_ID = process.env.NEXT_PUBLIC_SHOPIFY_APP_CLIENT_ID || ''
  const [host, setHost] = useState<string>()
  const [shop, setShop] = useState<string>()

  useEffect(() => {
    const url = new URL(window.location.href)
    const paramHost = url.searchParams.get('host')
    const paramShop = url.searchParams.get('shop')

    if (paramHost) setHost(paramHost)
    if (paramShop) setShop(paramShop)
  }, [])

  const appBridgeConfig: AppConfigV2 = {
    host: host || '',
    apiKey: SHOPIFY_APP_CLIENT_ID,
    forceRedirect: false,
  }

  return (
    <>
      {host && shop && (
        <AppBridgeProvider config={appBridgeConfig}>
          <AuthProvider host={host} shop={shop}>
            <PlanProvider>
              <RoutePropagator />
              {children}
            </PlanProvider>
          </AuthProvider>
        </AppBridgeProvider>
      )}
    </>
  )
}
